<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="fattureAcquistateFiltered"
      item-key="codice"
      sort-by="data"
      class="elevation-1"
      dense
      :loading="loading"
      hide-default-footer
      :single-expand="singleExpand"
      :expanded.sync="expanded"
      show-expand
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" dense>
                Acquista fatture
              </v-btn>
              <v-spacer></v-spacer>
            </template>
            <v-card>
              <v-card-title>
                <span class="text-h5">Acquisto fatture</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-select v-model="numeroFatture" label="Numero fatture" :items="numeriFatture" dense flat outlined item-text="descrizione" item-value="codice" return-object></v-select>
                    </v-col>
                  </v-row>                                          
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">Annulla</v-btn>
                <v-btn color="blue darken-1" text @click="save">Salva</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-switch v-model="soloAttivi" inset label="Solo acquisti attivi" title="Mostra solo gli acquisti che hanno ancora fatture attive"></v-switch>                
        </v-toolbar>
      </template>
      <template v-slot:[`item.statoAcquisto`]="{ item }">
        {{ item.statoAcquisto.descrizione }}
      </template>
<!--       <template v-slot:[`item.statoLicenza`]="{ item }">
        <span :class="verificaStatoLicenza(item.periodi) === 'Scaduta' ? 'red--text' : ''">{{ verificaStatoLicenza(item.periodi) }}</span>
      </template> -->
      <template v-slot:[`item.dataAcquisto`]="{ item }">
        {{ item.dataAcquisto | date }}
      </template>
      <template v-slot:[`item.dataScadenza`]="{ item }">
        {{ item.dataScadenza | date }}
      </template>    
<!--       <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" title="Modifica la licenza">mdi-pencil</v-icon>
        <v-icon small class="mr-2" @click="deleteItem(item)" title="Cancella la licenza">mdi-delete</v-icon>
        <v-icon small @click="duplicateItem(item)" title="Duplica la licenza">mdi-content-duplicate</v-icon>
      </template> -->
      <template v-slot:no-data>
        Nessuna acquisto effettuato
      </template>
<!--       <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length" class="licenzaSelected">
          <v-tabs dense v-model="tab[item.codice]">
            <v-tab key="associazioni" class="licenzaSelected">Associazioni<v-btn icon @click="trigRefreshLicenze++"><v-icon>mdi-refresh</v-icon></v-btn></v-tab>
            <v-tab key="rinnovi" class="licenzaSelected">Rinnovi<v-btn icon @click="trigRefreshLicenze++"><v-icon>mdi-refresh</v-icon></v-btn></v-tab>
            <v-tab key="uso" class="licenzaSelected">Uso<v-btn icon @click="trigRefreshLicenze++"><v-icon>mdi-refresh</v-icon></v-btn></v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab[item.codice]">
            <v-tab-item key="associazioni">
              <associazioni :codice="item.codice" :apikey="apikey" :associazioni="item.associazioni" :statoLicenza="item.statoLicenza" :statoAssociazione="item.statoAssociazione" :refresh="trigRefreshLicenze" @polling="onPolling" @unmap="onCancellaAssociazione"/>
            </v-tab-item>
            <v-tab-item key="rinnovi">
              <rinnovi :rinnovi="item.rinnovi" :refresh="trigRefreshLicenze"/>
            </v-tab-item>
            <v-tab-item key="uso">
              <uso :uso="item.uso" :refresh="trigRefreshLicenze"/>
            </v-tab-item>
          </v-tabs-items>
        </td>
      </template> -->
    </v-data-table>
    <v-snackbar v-model="snackbar" :color="snackbarColor" bottom><h4>{{ snackbarText }}</h4></v-snackbar> 
  </div>
</template>

<script>
  /* eslint-disable */
  import moment from 'moment'
  import { validazioni } from '@/mixins/validazioni.js'
  import acquisti from '@/services/acquistiService.js'

  const crypto = require('crypto');
  
  export default {
    mixins: [
      validazioni
    ],
    props: {
      apikey: String,
      trigger: Number
    },
    data: () => ({
      tab: {},
      loading: false,
      dialog: false,
      dialogDelete: false,
      fattureAcquistate: [],
      headers: [
        {
          text: 'Codice',
          align: 'start',
          sortable: false,
          value: 'codice',
        },
        { text: 'Data Acquisto', value: 'dataAcquisto' },
        { text: 'Data Scadenza', value: 'dataScadenza' },
        { text: 'Numero Fatture', value: 'numeroFatture' },
        { text: 'Usate', value: 'usate' },
        { text: 'Residuo', value: 'residuo' },
        { text: 'Stato', value: 'statoAcquisto' },
        { text: 'Actions', value: 'actions', sortable: false },
        { text: '', value: 'data-table-expand' }
      ],
      // per il totale fatture disponibili somma tutte quelle in stato attivo
      updateTrigger: 0,
      editedIndex: -1,
      editedItem: {
        codice: '',
        dataAcquisto: null,
        dataScadenza: null,
        numeroFatture: 0,
        residuo: 0,
        usate: 0,
        statoAcquisto: null
      },
      defaultItem: {
        codice: '',
        dataAcquisto: null,
        dataScadenza: null,
        numeroFatture: 0,
        residuo: 0,
        usate: 0,
        statoAcquisto: null
      },
      expanded: [],
      singleExpand: false,
      menuStart: [],
      menuEnd: [],
      statiAcquisto: [
        { codice: 'attivo', descrizione: 'Attivo' },
        { codice: 'sospeso', descrizione: 'Sospeso' },
        { codice: 'scaduto', descrizione: 'Scaduto' }
      ],
      numeriFatture: [
        { codice: 'n_15', descrizione: '15 - Quindici', costo: '', valore: 15 },
        { codice: 'n_50', descrizione: '50 - Cinquanta', costo: '', valore: 50 },
        { codice: 'n_100', descrizione: '100 - Cento', costo: '', valore: 100 },
        { codice: 'n_500', descrizione: '500 - Cinquecento', costo: '', valore: 500 }
      ],
      numeroFatture: null,
      snackbar: false,
      snackbarText: '',
      snackbarColor: '',
      soloAttivi: false
    }),
    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'Nuova licenza dispositivo' : 'Modifica licenza dispositivo'
      },
      rulesValidationRequired() {
        let rl = []
        rl.push(this.rules.required)
        return rl
      },
      rulesValidationEmail() {
        let rl = []
        rl.push(this.rules.required)
        rl.push(this.rules.email)
        return rl
      },
      fattureAcquistateFiltered() {
        return this.soloAttivi ? this.fattureAcquistate.filter(x => x.statoAcquisto.codice === 'attivo') : this.fattureAcquistate
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      dialogDelete (val) {
        val || this.closeDelete()
      },
    },
    async mounted() {
      await this.getDataFromApi()
    },
    methods: {
      dateFormat (date) {
        return this.formatDate(date)
      },
      formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      editItem (item) {
        this.editedIndex = this.fattureAcquistate.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },
      async duplicateItem(item) {
        this.editedIndex = -1
        this.editedItem = Object.assign({}, item)
        this.editedItem._id = ''
        delete this.editedItem._rev
        await this.save()
      },
      deleteItem (item) {
        this.editedIndex = this.fattureAcquistate.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialogDelete = true
      },
      async deleteItemConfirm () {
        // this.$emit('delete-fatture', this.apikey, this.editedItem)
        await acquisti.deleteAcquistoFattureCliente(this.apikey, this.editedItem.codice)
        this.fattureAcquistate.splice(this.editedIndex, 1)
        this.closeDelete()
      },
      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      closeDelete () {
        this.dialogDelete = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },
      async riattivaAcquistate(dataScadenza) {
        // riattiva eventuali fatture scadute ma con residuo = (acquisto - uso) positivo
        const daRiattivare = this.fattureAcquistate.filter(x => (x.residuo > 0 || (x.numeroFatture - x.usate) > 0) && x.statoAcquisto.codice === 'sospeso') 
        for (let r of daRiattivare) {
          r.statoAcquisto = this.statiAcquisto.find(x => x.codice === 'attivo')
          r.dataScadenza = dataScadenza
          await acquisti.updateAcquistoFattureCliente(this.apikey, r)    
        }
      },
      async save () {
        if (!this.numeroFatture) {
          return
        }
        if (this.editedIndex > -1) {
          // Verificare se possibilità di modifica
          Object.assign(this.fattureAcquistate[this.editedIndex], this.editedItem)
          await acquisti.updateAcquistoFattureCliente(this.apikey, this.editedItem)
        } else {
          this.editedItem.codice = crypto.randomBytes(16).toString('hex')
          this.editedItem.statoAcquisto = this.statiAcquisto.find(x => x.codice === 'attivo')
          this.editedItem.numeroFatture = this.numeroFatture.valore
          this.editedItem.dataAcquisto = moment().format('YYYY-MM-DD')
          this.editedItem.dataScadenza = moment().add(1, 'years').format('YYYY-MM-DD')
          await acquisti.updateAcquistoFattureCliente(this.apikey, this.editedItem)
          this.fattureAcquistate.push(this.editedItem)
          await this.riattivaAcquistate(this.editedItem.dataScadenza)
        }
        this.close()
      },
      async getDataFromApi () {
        try {
          this.loading = true
          let fattureAcquistateRaw = await acquisti.elencoAcquistiFattureCliente(this.apikey)
          this.fattureAcquistate = fattureAcquistateRaw
        } catch(err) {
          this.fattureAcquistate = []
        } finally {
          this.loading = false
        }
      }
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
  td.licenzaSelected {
    border-style: solid!important;
    border-width: 2px!important;
    border-color: #119432 !important;
  }
</style>
